import {useContext} from 'solid-js'
import {ConvivaProviderBehavior} from './ConvivaProvider'
import {ConvivaContext} from './ConvivaContext'

export function useConviva() {
    const contextValue: ConvivaProviderBehavior = useContext(ConvivaContext)
    if (!contextValue) {
        throw new Error('could not find ConvivaContext; please ensure the component is wrapped in a <ConvivaProvider>')
    }
    return contextValue
}
